import { RepresentativeType } from "../../../constants/representativeType";
import { ReferenceDataDomainKey } from "@duosoftbg/nacid-components";
import { IdentifierType } from "@duosoftbg/nacid-frontoffice-components";

export const baseUserInitialValues = {
  email: "",
  firstName: "",
  middleName: "",
  lastName: "",
  personalIdType: IdentifierType.NATIONAL_ID,
  personalId: "",
  personalNacidId: "",
  username: "",
  password: "",
  foreignerIdentifierKind: { id: "", name: "", domain: "FOREIGN_IDENTIFIER_TYPE" as ReferenceDataDomainKey },
  foreignerIdentifierCountry: { id: "", name: "" },
  birthCountry: { id: "", name: "" },
  birthPlace: "",
  birthSettlement: { id: "", name: "", fullSettlementName: "" },
  citizenship: { id: "", name: "" },
  dateOfBirth: "",
  humanitarianStatus: { id: "", name: "", domain: "HUMANITARIAN_STATUS" as ReferenceDataDomainKey },
  title: "",
  isRepresentative: false,
  representativeType: RepresentativeType.UNIVERSITY_REPRESENTATIVE,
  representedUniversity: "",
  representedCompany: "",
  representativeCapacity: "",
  resultReceive: { id: "", name: "", documentRecipient: false },
  enabled: false,
  emailVerified: false,
};
